import React from 'react';
import { Button } from '@material-ui/core';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import { IConfirmation } from './types';
import { useTranslation } from 'react-i18next';

export const Confirmation = ({
    open,
    setOpen,
    message,
    handleConfirm,
    ...props
}: IConfirmation) => {
    const { t } = useTranslation();

    return (
        <Dialog onClose={() => setOpen(false)} open={open} {...props}>
            <DialogTitle>{message}</DialogTitle>
            <DialogActions>
                <Button onClick={() => handleConfirm(false)} color="secondary">
                    {t('Buttons.Cancel')}
                </Button>
                <Button onClick={() => handleConfirm(true)} color="primary">
                    {t('Buttons.Submit')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
